import { useState } from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import http from "../../utils/http";
import { errorToastMessage } from "../../utils/toast";
import { AuthLayout, SignInWrapper } from "./EmailPassAuth/auth.style";
import { StyledButton } from "../Common/styles/button";
import { useAppDispatch } from "../../Redux/hooks";
import { setUserAuth } from "../../Redux/reducers/userSlice";
import { InputWrapper, LabelStyle } from "../Common/styles/form";
import { Logo } from "../Common/assets/Sidebar";
import { v4 as uuid } from "uuid";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const schema = yup.object({
  joincode: yup.string().required("* JoinCode is Required"),
});

const JoinCode = () => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (data: any) => {
    try {
      setSubmitLoader(true);
      const body: any = {
        joinCode: data.joincode,
        userAgent: window.navigator.userAgent,
        strategy: "join_code",
        deviceId: uuid(),
      };
      let url =
        "/participant/auth/login?user-agent=" + window.navigator.userAgent;
      const res = await http.post(url, body);
      const token = res.data.data.accessToken;
      const refreshToken = res.data.data.refreshToken;
      const userId = res.data.data.id;
      const firstName = res?.data?.data?.firstName || "";
      const lastName = res?.data?.data?.lastName || "";
      const studyId = res?.data?.data?.study?.id;
      const lang =
        res?.data?.data?.lang !== "en" ? res?.data?.data?.lang ?? "" : "";
      localStorage.setItem("role", "participant");
      localStorage.setItem("sm-access-token", token);
      localStorage.setItem("sm-refresh-token", refreshToken);
      localStorage.setItem("user-id", userId);
      localStorage.setItem("first-name", firstName);
      localStorage.setItem("last-name", lastName);
      localStorage.setItem("study-id", studyId);
      localStorage.setItem("lang", lang);
      const from = location.state?.from?.pathname
        ? location.state?.from?.pathname + location.state?.from?.search
        : "/home";
      dispatch(
        setUserAuth({ authenticated: true, role: "participant", userId })
      );
      navigate(from);
    } catch (err) {
      setSubmitLoader(false);
      errorToastMessage(err as Error);
    }
  };

  return (
    <Box sx={AuthLayout}>
      <Box sx={SignInWrapper}>
        {!submitLoader ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
              <Logo />
            </Box>
            <Formik
              initialValues={{
                joincode: "",
              }}
              onSubmit={handleSubmit}
              validationSchema={schema}
            >
              {({ errors, touched, getFieldProps }) => {
                return (
                  <Form>
                    <FormControl sx={InputWrapper}>
                      <FormLabel sx={LabelStyle} htmlFor="joincode">
                        Join Code
                      </FormLabel>
                      <TextField
                        placeholder="Join Code"
                        id="joincode"
                        {...getFieldProps("joincode")}
                        error={
                          touched?.joincode && errors?.joincode ? true : false
                        }
                        helperText={
                          touched?.joincode && errors?.joincode
                            ? errors?.joincode
                            : " "
                        }
                      />
                    </FormControl>

                    <StyledButton
                      variant="contained"
                      type="submit"
                      fullWidth
                      sx={{ mt: 2 }}
                    >
                      Login
                    </StyledButton>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      Not a participant?{" "}
                      <NavLink to="/auth/login">Click here</NavLink>
                      <span> to login as Admin</span>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              justifyContent: "center",
              alignItems: "center",
              height: "450px",
            }}
          >
            <CircularProgress size={100} thickness={2} />
            <Typography color="text.primary" fontWeight={600} fontSize="16px">
              Logging you in
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default JoinCode;
